<template>
  <div style="margin-top: -20px !important">
    <!-- Header part -->
    <RecordNotFound v-if="status_code == 404" :message="status_message"></RecordNotFound>
    <template v-else>
      <b-row
        class="hidden-sm-down d-print-none px-pad py-2 border-bottom justify-content-center align-items-center"
        style="height: 65px"
      >
        <b-col cols="6" class="text-left px-0">
          <div class="d-flex w-100">
            <span>
              <i class="la la-cube img-circle"></i>
            </span>
            <div class="mx-2 mt-2 w-75">
              <h5 class="mb-1 text-truncate w-100">{{ list.main_detail.pdt_name }}</h5>
              <small class="text-muted fw-semi-bold mb-2">
                <b-badge variant="primary" size="xs" style="height: 20px">
                  {{
                  (list.main_detail.pdt_status == 1 || active_change == true) &&
                  inactive_change != true
                  ? "Active"
                  : "InActive"
                  }}
                </b-badge>
              </small>
            </div>
          </div>
        </b-col>

        <b-col cols="6" class="text-right px-0">
          <b-button
            variant="primary"
            size="sm"
            class="mr-2"
            v-if="RoutePermission(false,'','invoice','amcservice','create')"
            :to="{ name: 'AmcServiceCreate', query:{page_from:'view',old_id:$route.params.id}}"
          >New Product Bundle</b-button>

          <!-- <b-button variant="success" size="sm">New Invoice</b-button> -->
          <b-button-group variant="light">
            <b-button
              size="sm"
              v-if="RoutePermission(false, '', 'invoice', 'amcservice', 'update')"
              :to="{ name: 'AmcServiceUpdate', params: { id: $route.params.id },query:{page_from:'view'} }"
              variant="light"
            >
              <i class="la la-edit la-lg"></i>
            </b-button>

            <b-button
              variant="light"
              size="sm"
              title="delete"
              v-if="
              list.main_detail.is_used == 0 &&
              RoutePermission(false, '', 'invoice', 'amcservice', 'delete')
            "
              @click="
              handlingapprovingmodal({
                content:
                  'Are you sure you want to delete this Product Bundle ?',
                title: 'Delete Product Bundle - ' + list.main_detail.pdt_name,
                module: 'amcservice/deleteproduct',
                data: JSON.stringify({
                  id: $route.params.id,
                }),
                RoutePlace: 'AmcService',
                isRoute: 'true',
                type: 'delete',
                route_history: bundle_index_history,
              })
            "
            >
              <i class="glyphicon glyphicon-trash"></i>
            </b-button>
            <b-dropdown
              right
              variant="light"
              no-caret
              size="sm"
              style="height: 33px !important"
              v-if="
              RoutePermission(false, '', 'invoice', 'amcservice', 'update') ||
              RoutePermission(true, 'AmcServiceCreate', '', '', '')
            "
            >
              <template slot="button-content">
                <i class="glyphicon glyphicon-option-vertical" style="padding-bottom: 3px"></i>
              </template>
              <b-dropdown-item
                v-if="
                RoutePermission(false, '', 'invoice', 'amcservice', 'update')
              "
                @click="
                statusChange();
                status =
                  (list.main_detail.pdt_status == 1 || active_change == true) &&
                  inactive_change != true
                    ? 'inactive'
                    : 'active';
              "
              >
                {{
                (list.main_detail.pdt_status == 1 || active_change == true) &&
                inactive_change != true
                ? "Mark as In Active"
                : "Mark as Active"
                }}
              </b-dropdown-item>
              <b-dropdown-item
                v-if="RoutePermission(true, 'AmcServiceCreate', '', '', '')"
                :to="{
                name: 'AmcServiceCreate',
                query: { clone_id: $route.params.id,page_from:'view' },
              }"
              >Clone Product</b-dropdown-item>
            </b-dropdown>
            <b-button
              variant="light"
              size="sm"
              title="close"
              :to="bundle_index_history ? bundle_index_history : { name: 'AmcService' }"
            >
              <i class="la la-remove la-lg text-decoration-none"></i>
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>

      <!--  Tab Details -->
      <div class="d-flex" style="margin-left: -20px; margin-right: -20px">
        <div class="view-content-block border-left d-none d-lg-block">
          <div class="py-3">
            <!--  Item Details -->
            <h6
              class="fw-semi-bold theme-text-color px-pad"
              style="padding-bottom: 6px"
            >Product Details</h6>
            <div class="border-bottom"></div>

            <b-row class="px-pad py-2">
              <b-col cols="4">Name</b-col>
              <b-col cols="8" class="text-truncate">
                {{
                list.main_detail.pdt_name
                }}
              </b-col>
            </b-row>
            <b-row class="px-pad py-2">
              <b-col cols="4">Type</b-col>
              <b-col cols="8">{{ list.main_detail.pdt_type }}</b-col>
            </b-row>
            <b-row class="px-pad py-2">
              <b-col cols="4">Unit</b-col>
              <b-col cols="8" class="text-truncate">
                {{
                list.main_detail.unit_name
                }}
              </b-col>
            </b-row>

            <div class="border-bottom"></div>
            <template
              v-if="
              pdt_settings_details.custom_field.filter(
                (custom_field) =>
                  list.main_detail[custom_field.field_name] &&
                  custom_field.status == 1 && custom_field.permissions != 'hide'
              ).length != 0
            "
            >
              <h6 class="fw-semi-bold theme-text-color px-pad py-3 m-0">Custom Fields</h6>
              <div class="border-bottom"></div>
              <b-row
                class="px-pad py-2"
                v-for="custom_field in pdt_settings_details.custom_field"
                :key="custom_field.id"
                v-if="
                list.main_detail[custom_field.field_name] &&
                custom_field.status == 1 && custom_field.permissions != 'hide'
              "
              >
                <b-col cols="4" class="text-truncate">
                  {{
                  custom_field.label_name
                  }}
                </b-col>

                <b-col
                  cols="8"
                  :key="custom_field.id"
                  v-if="custom_field.datatype == 'select'"
                  class="text-truncate"
                >
                  {{
                  getJsonPresentValue(
                  custom_field.options,
                  "value",
                  list.main_detail[custom_field.field_name],
                  "label"
                  )
                  }}
                </b-col>
                <b-col
                  cols="8"
                  :key="custom_field.id"
                  v-else-if="custom_field.datatype == 'date'"
                  class="text-truncate"
                >{{ getDateFormat(list.main_detail[custom_field.field_name]) }}</b-col>
                <b-col
                  cols="8"
                  :key="custom_field.id"
                  v-else-if="custom_field.datatype == 'amount'"
                  class="text-truncate"
                >
                  {{
                  orgCurrencySymbol +
                  " " +
                  list.main_detail[custom_field.field_name]
                  }}
                </b-col>
                <b-col
                  cols="8"
                  :key="custom_field.id"
                  v-else-if="custom_field.datatype == 'checkbox'"
                >
                  {{
                  list.main_detail[custom_field.field_name] == 1
                  ? "True"
                  : "False"
                  }}
                </b-col>
                <b-col
                  class="text-truncate"
                  cols="8"
                  :key="custom_field.id"
                  v-else
                >{{ list.main_detail[custom_field.field_name] }}</b-col>
              </b-row>
              <div class="border-bottom"></div>
            </template>
            <h6
              class="fw-semi-bold theme-text-color px-pad"
              style="padding-bottom: 6px; padding-top: 10px"
            >Sales Details</h6>
            <div class="border-bottom"></div>

            <b-row class="px-pad py-2">
              <b-col cols="6">Selling Price</b-col>
              <b-col cols="6" class="text-truncate">
                {{ orgCurrencySymbol }}
                {{ parseFloat(list.main_detail.pdt_sal_price) }}
              </b-col>
            </b-row>
            <b-row class="px-pad py-2">
              <b-col cols="6">Sales Account</b-col>
              <b-col cols="6" class="text-truncate">
                {{
                list.main_detail.sales_account
                }}
              </b-col>
            </b-row>
            <b-row
              class="px-pad py-2"
              v-if="
              list.main_detail.sales_desc != '' &&
              list.main_detail.sales_desc != null
            "
            >
              <b-col cols="6">Description</b-col>
              <b-col cols="6" class="text-truncate">
                {{
                list.main_detail.sales_desc
                }}
              </b-col>
            </b-row>

            <div class="border-bottom"></div>
            <template>
              <b-tabs class="customer_view_tab custom-tab" card>
                <b-tab
                  title="Tax Details"
                  active
                  class="px-pad py-2"
                  title-link-class="text-center"
                >
                  <!-- <div class="d-flex w-100 py-2">
                  <div class="cus-view-addr w-50 text-muted">Tax Preference</div>
                  <div
                    class="cus-view-addr w-50"
                  >{{ list.main_detail.tax_preference==0 ?'Tax Exempt':'Taxable'}}</div>
                </div>
                <div class="d-flex w-100 py-2" v-if="list.main_detail.tax_preference==0">
                  <div class="cus-view-addr w-50 text-muted">Exempt Reason</div>
                  <div class="cus-view-addr w-50">{{ list.main_detail.exempt_reason_name}}</div>
                  </div>-->
                  <div
                    class="d-flex w-100 py-2"
                    v-if="
                    list.main_detail.tax_details[list.main_detail.pdt_tax_id]
                  "
                  >
                    <div class="cus-view-addr w-50 text-muted">Intra State Tax Rate</div>
                    <div class="cus-view-addr w-50">
                      {{
                      list.main_detail.tax_details[list.main_detail.pdt_tax_id]
                      .tax_name
                      }}
                    </div>
                  </div>
                  <div
                    class="d-flex w-100 py-2"
                    v-if="
                    list.main_detail.tax_details[
                      list.main_detail.pdt_inter_tax_id
                    ]
                  "
                  >
                    <div class="cus-view-addr w-50 text-muted">Inter State Tax Rate</div>
                    <div class="cus-view-addr w-50">
                      {{
                      list.main_detail.tax_details[
                      list.main_detail.pdt_inter_tax_id
                      ].tax_name
                      }}
                    </div>
                  </div>
                </b-tab>
                <b-tab
                  title="Additional Details"
                  class="px-pad py-2"
                  title-link-class="text-center"
                >
                  <template
                    v-if="
                    list.main_detail.pdt_hsn ||
                    list.main_detail.pdt_sku ||
                    list.main_detail.pdt_tags
                  "
                  >
                    <div class="d-flex w-100 py-2" v-if="list.main_detail.pdt_hsn">
                      <div class="cus-view-addr w-50 text-muted">HSN Code</div>
                      <div class="cus-view-addr w-50">{{ list.main_detail.pdt_hsn }}</div>
                    </div>
                    <div class="d-flex w-100 py-2" v-if="list.main_detail.pdt_sku">
                      <div class="cus-view-addr w-50 text-muted">SKU</div>
                      <div class="cus-view-addr w-50">{{ list.main_detail.pdt_sku }}</div>
                    </div>

                    <!-- <div class="d-flex w-100 py-2" v-if="list.main_detail.pdt_legacy_id">
                    <div class="cus-view-addr w-50 text-muted">Legacy Id</div>
                    <div class="cus-view-addr w-50">{{list.main_detail.pdt_legacy_id}}</div>
                    </div>-->
                    <div class="d-flex w-100 py-2" v-if="list.main_detail.pdt_tags">
                      <div class="cus-view-addr w-50 text-muted">Product Tags</div>
                      <div class="cus-view-addr w-50">{{ list.main_detail.pdt_tags }}</div>
                    </div>
                    <!-- <div class="d-flex w-100 py-2" v-if="list.main_detail.pdt_desc">
                    <div class="cus-view-addr w-50 text-muted">Product Notes</div>
                    <div class="cus-view-addr w-50">{{list.main_detail.pdt_desc}}</div>
                    </div>-->
                  </template>
                  <template v-else>
                    <span class="text-muted pt-2 pb-2">No additional details to display</span>
                  </template>
                </b-tab>
              </b-tabs>
            </template>

            <template
              v-if="
              reporting_tags.filter(
                (tag) =>
                  list.main_detail[tag.tag_column_name] != '' &&
                  list.main_detail[tag.tag_column_name] != null
              ).length != 0
            "
            >
              <div class="border-bottom"></div>
              <h6
                class="fw-semi-bold theme-text-color px-pad pt-3 cursor_pointer"
                style="padding-bottom: 6px"
              >Reporting Tags</h6>
              <div class="border-bottom"></div>
              <!--  Selling and ales accountant -->

              <div class="w-100 px-pad">
                <div
                  class="d-flex w-100 py-2"
                  v-for="(tag, index) in reporting_tags"
                  :key="index"
                  v-if="
                  list.main_detail[tag.tag_column_name] != '' &&
                  list.main_detail[tag.tag_column_name] != null &&
                  list.main_detail[tag.tag_column_name] != 0
                "
                >
                  <div class="cus-view-addr w-50 text-muted">{{ tag.tag_name }}</div>

                  <div class="cus-view-addr w-50">
                    {{
                    getJsonPresentValue(
                    tag.tag_options,
                    "value",
                    list.main_detail[tag.tag_column_name],
                    "label"
                    )
                    }}
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="view-tab-block">
          <ProductView :list="list" page="AmcServiceView"></ProductView>

          <!--  Recurring invoice-->
        </div>
      </div>

      <statuschange
        module="amcservice"
        :statuschange="status"
        :id="list.main_detail.pdt_id"
        :status="list.main_detail.pdt_status"
        @active_status="activechange()"
        @inactive_status="inactivechange()"
      ></statuschange>
      <GlobalModal
        :content="content"
        :module="module"
        :title="title"
        :data="globalmodaldata"
        :isRoute="isRoute"
        :RoutePlace="RoutePlace"
        :type="globalmodaltype"
        :route_history="route_history"
        v-on:setSuccessHandlingModal="
        list.sales_order_header_detail.order_status = 2;
        list.sales_order_header_detail.order_status_name = 'Approved';
      "
      />
    </template>
  </div>
</template>
<script>
import getPageTitle from "@/utils/get-page-title"; // to set page title
import { mapState, mapGetters } from "vuex";
import { notificationMixin } from "@/mixins/notification";
import ProductView from "@/components/Form/Product/ProductView";
import statuschange from "@/components/Modal/Product/StatusChangeModal";
import RecordNotFound from "@/pages/Error/RecordNotFound";
import store from "@/store/index";
export default {
  mixins: [notificationMixin],
  components: {
    ProductView,
    statuschange,
    RecordNotFound
  },
  data() {
    return {
      isRoute: "",
      RoutePlace: "",
      status: "",
      content: "",
      module: "",
      globalmodaltype: "",
      globalmodaldata: "",
      title: "",
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      active_change: false,
      inactive_change: false,
      route_history: ""
    };
  },

  methods: {
    statusChange() {
      this.$root.$emit("bv::show::modal", "statuschange");
    },
    activechange() {
      this.active_change = true;
      this.inactive_change = false;
    },
    inactivechange() {
      this.inactive_change = true;
    },
    //  delete whole product
    handlingapprovingmodal(ev) {
      this.content = ev.content;
      this.module = ev.module;
      this.globalmodaldata = ev.data;
      this.title = ev.title;
      this.isRoute = ev.isRoute;
      this.RoutePlace = ev.RoutePlace;
      this.globalmodaltype = ev.type;
      this.route_history = ev.route_history || "";
      this.$root.$emit("bv::show::modal", "handlingapprovingmodal");
    }
  },

  created() {
    if (this.status_code != 404) {
      document.title = getPageTitle(
        this.list.main_detail.pdt_name + " | " + this.$route.meta.title
      );
    }
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    ...mapState({
      list: state => state.amcservice.listView,
      code: state => state.amcservice.code,
      status_code: state => state.amcservice.status_code,
      status_message: state => state.amcservice.status_message,
      status_type: state => state.amcservice.status_type,
      bundle_index_history: state => state.amcservice.bundle_index_history
    }),
    ...mapGetters([
      "reporting_tags",
      "orgCurrencySymbol",
      "pdt_settings_details"
    ])
  }
};
</script>

